import { Modal } from "react-bootstrap";

export const BaseModal = (props: { header?: any, title? : any, bodyHtml? : any, childBody? : any, footer? : any, show : boolean, handleClose : () => void, size? : any, closingDisabled? : boolean, closeOnBackdrop? : boolean, footerCentered? : boolean }) => {

  let headerContent = null;
  if (props.header !== undefined) {
    headerContent = props.header;
  } else {
    headerContent = <Modal.Title>{ props.title} </Modal.Title>;
  }

  let bodyContent = null;
  if (props.childBody !== undefined) {
    bodyContent = props.childBody;
  } else {
    bodyContent = <div dangerouslySetInnerHTML={{ __html: props.bodyHtml }} />;
  }

  let footer = null;
  if (props.footer !== undefined) {
    const footerClass = props.footerCentered ? "sk-modal-footer" : "";
    footer = (
      <Modal.Footer className={footerClass}>
        {props.footer}
      </Modal.Footer>
    );
  }

  const hideRequested = () => {
    if (props.closingDisabled) return;
    props.handleClose();
  }

  let header = <>
    <Modal.Header closeButton={!props.closingDisabled}>
      { headerContent }
    </Modal.Header>
  </>  

  const closingOnBackdropEnabled = props.closeOnBackdrop === false  ? 'static' : true;

  return (
    <>
      <Modal show={props.show} onHide={hideRequested} size={props.size} backdrop={closingOnBackdropEnabled}>
        {header}
        <Modal.Body>
          { bodyContent }
        </Modal.Body>
        { footer }
      </Modal>
    </>
  );
}
